(function () {
  'use strict';

  angular
      .module('tf.retailer')
      .controller('AnalyticsCtrl', AnalyticsCtrl);

  // @ngInject
  function AnalyticsCtrl($state, experiments, stores, orderByFilter, Auth) {
    var vm = this;

    vm.userTlas = Auth.getUser().storeTlas;
    vm.tla = $state.params.tla;
    vm.experiments = experiments;
    // There will be no stores if the user doesn't have permission to change retailers
    if (stores) {
      // Sort them here so we can force the first option
      stores = orderByFilter(stores, 'name');
      // The first option is 'None'
      stores.unshift({ tla : null, name : 'dashboard.retailer.none' });
    }
    vm.stores = stores;

    vm.assumeRole = function () {
      $state.go('.', { tla : vm.tla });
    };

    vm.goToAnalytics = function (experiment) {
      var params = { tla : experiment.tla };
      if (experiment.key) {
        params.experiment = experiment.key;
      }
      $state.go('results', params);
    };

    vm.canSeeReports = function () {
      return vm.userTlas.length || Auth.can('retailerChangeTla');
    };

    vm.getUserTlas = function () {
      var tlas = vm.userTlas;
      if (vm.tla && Auth.can('retailerChangeTla')) {
        tlas = _.uniq(tlas.concat(vm.tla));
      }
      return tlas;
    };
  }

})();
